module.exports = __webpack_public_path__ + "img/today-landscape.09ac914b.jpg";